module.exports = __webpack_public_path__ + "img/Transactioncircle.c65e5c71.png";